module.exports = __webpack_public_path__ + "img/zhyly-1.159f8a00.png";